export const MIN_PAYOUT_AMOUNT = 20;
